import { useEffect, useState } from 'react'
import ListingComponent from '../../Components/Molecule/ListingComponent'
import CONSTANTS, { PAGES_ROUTES } from '../../Constants'
import { deleteConfirmationDialog, REVOKE_ACCESS } from '../../Constants/Texts'
import { combineErrorMessage, getDateInFormat, handleResponse } from '../../Helpers/Util'
import mainApiService from '../../Services'
import { useAppDispatch } from '../../Store/Hooks'
import { useNavigate } from 'react-router-dom'
import { showAlert } from '../../Store/Slice/alert.slice'
import updateTagMetaData from '../../Helpers/UpdateTagMetaData'
import { DeleteIcon } from '../../Components/Icons'
import { REVOKE_ACCESS_API } from '../../Constants/ApiDefinations'
import RoleConfirmation from '../../Components/Dialogs/RoleConfirmation'

const RevokeAccessListing = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const [isLoader, setIsLoader] = useState<boolean>(true)
  const [dataCount, setDataCount] = useState(0)
  const [listData, setListData] = useState<any[]>([])
  const [dialogProps, setDialogProps] = useState({
    open: false,
    heading: '',
    description: '',
    color: 'primary',
  })
  const [deleteId, setDeleteId] = useState<string>('')
  const [searchFunctionFilters, setSearchFunctionFilters] = useState<{
    sortBy: string | number
    filterValue: string
    sortType: number
    page: number
    limit: number
  }>({ sortBy: '', filterValue: '', sortType: 0, page: 1, limit: 10 })

  useEffect(() => {
    updateTagMetaData({ title: 'Revoke Access' })
    return () => {
      updateTagMetaData({})
    }
  }, [])

  const getRevokeAccessListingData = async (options: any) => {
    setIsLoader(true)
    const defaultOptions = {
      page: 1,
      limit: 10,
    }

    const { page = defaultOptions.page, limit = defaultOptions.limit } = options
    const payload: any = {
      sortType: options.sortType ? options.sortType : -1,
      page,
      limit,
    }

    if (options.sortBy) {
      payload.sortBy = options.sortBy
    }
    if (options.filterValue) {
      payload.searchText = options.filterValue
    }

    const requestedData = REVOKE_ACCESS_API.LIST(payload)
    const result: any = await mainApiService(requestedData)
    const { responseCode } = handleResponse(result)
    if (result?.responseCode === 200) {
      const record = result?.data?.records
      const tempData: any[] = []
      record.forEach((item: any) => {
        tempData.push({
          _id: item?._id,
          title: item?.title,
          startDateTime: getDateInFormat(
            item?.startDateTime as string,
            CONSTANTS.DATE_FORMAT_TIME_SECONDS,
          ),
          endDateTime: getDateInFormat(
            item?.endDateTime as string,
            CONSTANTS.DATE_FORMAT_TIME_SECONDS,
          ),
          action: (
            <button
              onClick={(e) => handleDelete(e, item)}
              data-testid='access-delete-btn'
              className='delete-icon-with-bg'
            >
              <DeleteIcon />
            </button>
          ),
          rowURL: `/${PAGES_ROUTES.BoltMasterNew}/${PAGES_ROUTES.RevokeAccess}/edit/${item?._id}`,
        })
      })
      setDataCount(result?.data?.count)
      setListData(tempData)
    } else if (responseCode === 404) {
      setDataCount(0)
      setListData([])
    } else {
      dispatch(showAlert([true, combineErrorMessage(result), 'error']))
    }
    setIsLoader(false)
  }

  const handleDelete = (e: React.MouseEvent, item: any) => {
    e.preventDefault()
    setDeleteId(item?._id)
    setDialogProps({
      open: true,
      heading: REVOKE_ACCESS.DELETE_DIALOG_HEADING,
      description: deleteConfirmationDialog(item?.title),
      color: 'error',
    })
  }

  const handleClose = () => {
    setDialogProps({
      heading: '',
      description: '',
      color: 'primary',
      open: false,
    })
  }

  const handleProceedDelete = async () => {
    const requestData = REVOKE_ACCESS_API.DELETE(deleteId)
    const result = await mainApiService(requestData)
    if (result?.responseCode === 200) {
      handleClose()
      getRevokeAccessListingData(searchFunctionFilters)
    } else {
      dispatch(showAlert([true, combineErrorMessage(result), 'error']))
    }
  }

  return (
    <>
      <ListingComponent
        isRetainFilters
        columns={REVOKE_ACCESS.COLUMN_HEADER}
        tableRows={listData}
        dataCount={dataCount}
        isLoading={isLoader}
        cloneToDisable='title'
        headerBtnLable={REVOKE_ACCESS.CREATE_LABEL}
        tableTitle={REVOKE_ACCESS.TITLE}
        searchPlaceholder={REVOKE_ACCESS.SEARCH_PLACEHOLDER}
        searchFunction={(search, sorttype, coltype, filters, pagenumber, pagecount) => {
          getRevokeAccessListingData({
            sortBy: coltype,
            filterValue: search,
            sortType: sorttype,
            page: pagenumber,
            limit: pagecount,
            filters,
          })
          setSearchFunctionFilters((pre) => ({
            ...pre,
            sortBy: coltype,
            filterValue: search,
            sortType: sorttype,
            page: pagenumber,
            limit: pagecount,
          }))
        }}
        isRowClickable
        paginationOption={CONSTANTS.PAGINATION_OPTIONS}
        createButtonClick={() => {
          navigate(`/${PAGES_ROUTES.BoltMasterNew}/${PAGES_ROUTES.RevokeAccess}/create`)
        }}
      />
      <RoleConfirmation
        {...dialogProps}
        handleSuccess={handleProceedDelete}
        handleClose={handleClose}
        cancelButtonLabel='Cancel'
        successButtonLabel='Delete'
        Icon='DeleteRoleIcon'
        color='error'
      />
    </>
  )
}

export default RevokeAccessListing
